/**
 * **حضر إمتى وانصرف إمتى — من برّه** (قرار المالك 01/10/2026: «عاوز جنب 0 دقيقة / 10 ساعات دي يبقى جنبها الموظف حضر
 * إمتى وانصرف إمتى، علشان الموضوع إني أدخل جوّه ده فرهدة»): أوّل حضورٍ وآخر انصرافٍ في اليوم بساعة القاهرة، ومن
 * لا يزال في جلسةٍ مفتوحة «لسه موجود». يُعرض في «لوحة اليوم» وفي بطاقات الـKPI للأدمن.
 */
import type { AttendanceDay } from '../lib/api.ts';
import { cairoStamp } from '../lib/format.ts';

export function InOutTimes({ day, className = '' }: {
  day: Pick<AttendanceDay, 'checkedIn' | 'firstCheckInAt' | 'checkedOut' | 'lastCheckOutAt' | 'openSession'> & { dayIsFinal?: boolean };
  className?: string;
}) {
  const inAt = cairoStamp(day.firstCheckInAt)?.time;
  if (!day.checkedIn || !inAt) return <span className={`text-xs text-ink-500 ${className}`}>مسجّلش حضور</span>;
  const outAt = cairoStamp(day.lastCheckOutAt)?.time;
  return (
    <span className={`inline-flex flex-wrap items-center gap-x-2 text-xs tabular-nums ${className}`}>
      <span className="font-semibold text-emerald-700">حضر {inAt}</span>
      <span className="text-ink-400">·</span>
      {/* يومٌ انتهى بلا انصراف ليس «لسه موجود» (02/10/2026، مع اختيار اليوم في اللوحة): عمار ظهر «لسه موجود» على يومٍ فات */}
      {(day.openSession || !day.checkedOut || !outAt) && day.dayIsFinal
        ? <span className="font-semibold text-rose-700">ماسجّلش انصراف</span>
        : day.openSession || !day.checkedOut || !outAt
        ? <span className="font-semibold text-amber-700">لسه موجود</span>
        : <span className="font-semibold text-rose-700">انصرف {outAt}</span>}
    </span>
  );
}
